export default __webpack_public_path__ + "static/media/button_app_store.9907b402.png";